/* Burgon & Ball USA stock rules — see snippets/bb-stock-guard.liquid */
(function () {
  var S = window.BB_STOCK || { b2b: false, map: {}, cartCount: 0 };
  var MAP = S.map || {};
  var nativeFetch = window.fetch.bind(window);
  var MSG_KEY = 'bbStockMsg';

  function stockFor(id) {
    id = String(id || '');
    return Object.prototype.hasOwnProperty.call(MAP, id) ? MAP[id] : null;
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 'bb-stock-toast';
    t.setAttribute('role', 'status');
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 7000);
  }

  function noteFor(form) {
    var n = form.querySelector('.bb-stock-note');
    if (!n) {
      n = document.createElement('p');
      n.className = 'bb-stock-note';
      form.appendChild(n);
    }
    return n;
  }

  /* ---------- Product forms ---------- */
  function applyForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      var input = f.querySelector('[name="id"]');
      if (!input) continue;
      var s = stockFor(input.value);
      if (s === null) continue;

      if (S.b2b) {
        var note = f.querySelector('.bb-stock-note');
        if (s <= 0) {
          noteFor(f).textContent = 'Available on backorder — ships as soon as it is back in stock.';
        } else if (note) {
          note.remove();
        }
        continue;
      }

      var btns = f.querySelectorAll('button[type="submit"], button[name="add"], input[type="submit"]');
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        if (s <= 0) {
          if (b.dataset.bbSold !== '1') {
            b.dataset.bbOrig = b.innerHTML;
            b.dataset.bbSold = '1';
          }
          b.disabled = true;
          b.setAttribute('aria-disabled', 'true');
          if (b.textContent.trim() !== 'Sold out') b.textContent = 'Sold out';
        } else if (b.dataset.bbSold === '1') {
          b.dataset.bbSold = '';
          b.disabled = false;
          b.removeAttribute('aria-disabled');
          if (b.dataset.bbOrig) b.innerHTML = b.dataset.bbOrig;
        }
      }
      var scope = f.closest('section') || document;
      var tags = scope.querySelectorAll('span, p, div, small, strong');
      for (var q = 0; q < tags.length; q++) {
        var el = tags[q];
        if (s <= 0 && el.children.length === 0 && el.textContent.trim() === 'Backordered') el.textContent = 'Sold out';
      }
      var pay = f.querySelectorAll('.shopify-payment-button');
      for (var k = 0; k < pay.length; k++) pay[k].style.display = s <= 0 ? 'none' : '';
      var qty = f.querySelector('input[name="quantity"]') ||
        document.querySelector('input[name="quantity"][form="' + (f.id || '__none') + '"]');
      if (qty && s > 0) qty.max = s;
    }
  }

  if (Object.keys(MAP).length) {
    applyForms();
    document.addEventListener('change', function () { setTimeout(applyForms, 50); }, true);
    setInterval(applyForms, 500);
  }

  if (S.b2b) return; /* wholesale: no cart limits */

  /* ---------- Cart limits (consumers) ---------- */
  var busy = null;

  function checkCart() {
    if (busy) return busy;
    busy = nativeFetch('/cart?view=bbstock', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d;
        try { d = JSON.parse(t); } catch (e) { return false; }
        var over = (d.items || []).filter(function (i) {
          return i.tracked && i.quantity > Math.max(i.available, 0);
        });
        if (!over.length) return false;
        var chain = Promise.resolve();
        over.forEach(function (i) {
          chain = chain.then(function () {
            return nativeFetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: i.key, quantity: Math.max(i.available, 0) })
            });
          });
        });
        return chain.then(function () {
          var names = over.map(function (i) {
            return i.available > 0 ? i.title + ' (only ' + i.available + ' left)' : i.title + ' (sold out)';
          });
          try { sessionStorage.setItem(MSG_KEY, names.join(', ')); } catch (e) {}
          location.reload();
          return true;
        });
      })
      .catch(function () { return false; })
      .then(function (fixed) { busy = null; return fixed; });
    return busy;
  }

  /* Re-check after anything that changes the cart */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update)/.test(url)) {
      p.then(function () { setTimeout(checkCart, 0); }, function () {});
    }
    return p;
  };


  /* Message after a correction */
  try {
    var m = sessionStorage.getItem(MSG_KEY);
    if (m) {
      sessionStorage.removeItem(MSG_KEY);
      toast('We updated your cart to match what we have in stock: ' + m + '.');
    }
  } catch (e) {}

  if (S.cartCount > 0) checkCart();
})();
